import * as React from 'react';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import {style} from 'typestyle';
import {colorSlate} from '../theme/color';
import {em, px} from 'csx';
import {observer} from 'mobx-react';
import {fontHeading} from '../theme/font';
import {TrackSchema} from '../types/schema';
import {ImagePreloader} from '../types/fn';
import {GenericCarouselTracks} from "./page-home-generic-carousel-tracks";

export interface GenericCarouselProps {
    tracks: Array<TrackSchema>;
    preload: ImagePreloader;
    PlayButton: any;
    onClickLink(event: React.MouseEvent<any>): void;
    AddRemove: any;
    Favourite: any;
    i18n?: {
        title: string;
    }
}

const DEFAULT_I18N = {
    title: 'Ending soon'
};

export const GenericCarousel = observer<GenericCarouselProps>(({ tracks, onClickLink, i18n = DEFAULT_I18N, PlayButton, AddRemove, Favourite, preload }) => (
    <div className={styles.container}>
        <div>{i18n.title}</div>
        <GenericCarouselTracks
            tracks={tracks}
            PlayButton={PlayButton}
            AddRemove={AddRemove}
            Favourite={Favourite}
            onClickLink={onClickLink}
            preload={preload}
        />
    </div>
));

const styles = {
    container: style(
        {
            position: 'relative',
            margin: '40px 0 0 0',
            color: colorSlate.toString(),
            fontWeight: 500,
            $nest: {
                '&> div:first-child': {
                    margin: '0 0 20px 0',
                    fontSize: px(20),
                    fontFamily: fontHeading,
                    letterSpacing: em(-0.0625)
                }
            }
        },
        mediaMobileOnly({
            $nest: {
                '&> div:first-child': {
                    padding: '0 20px'
                }
            }
        }),
        mediaTablet({
            $nest: {
                '&> div:first-child': {
                    padding: '0 40px'
                }
            }
        })
    )
}